import { render, staticRenderFns } from "./EventTimeline.vue?vue&type=template&id=1b1b64cb&scoped=true"
import script from "./EventTimeline.vue?vue&type=script&lang=js"
export * from "./EventTimeline.vue?vue&type=script&lang=js"
import style0 from "./EventTimeline.vue?vue&type=style&index=0&id=1b1b64cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1b64cb",
  null
  
)

export default component.exports